<template>
  <section>
    <b-container fluid class="mt-4">
      <b-row class="section-content">
        <b-col cols="12" lg="3" class="mb-4">
          <b-card>
            <b-img
              class="profile-picture"
              rounded="circle"
              height="200"
              width="200"
              alt="Photo de profil"
              :src="currentUser.picture"
            />
            <p class="user-name">{{ currentUser.username }}</p>
            <p
              v-if="currentUser.birthdate || currentUser.gender || currentUser.address"
              class="user-infos"
            >
              <span>{{ getAge($moment, currentUser) }}</span>
              <span v-html="getGender(currentUser)"></span>
              <span>{{ getCity(currentUser) }}</span>
            </p>
            <p v-if="userInstruments" class="user-instruments">{{ userInstruments }}</p>
            <div
              v-if="loggedUser.id !== currentUser.id || loggedUser.id !== currentUser.id && loggedUser.role === 'admin'"
              class="mb-4"
            >
              <b-button
                v-if="friendship === null"
                variant="primary"
                size="md"
                @click="sendFriendRequest({ fromUser: loggedUser.id, toUser: currentUser.id })"
                class="mb-0"
                :disabled="friendshipStatus.sending"
              >
                Demande d'ajout
                <i class="fa fa-plus fa-lg fa-fw"></i>
              </b-button>
              <i v-show="friendshipStatus.sending" class="loader fa fa-spinner fa-spin fa-2x"></i>
              <span v-if="friendship && friendship.accepted === false">
                Demande d'ajout en attente
                <i class="fa fa-hourglass fa-fw"></i>
              </span>
              <span
                v-if="friendship && friendship.accepted === true"
              >Vous êtes amis depuis le {{ friendship.updatedAt | moment("DD/MM/YY") }}</span>
            </div>
            <div
              v-if="loggedUser.id !== currentUser.id && (friendship && friendship.accepted === true || loggedUser.role === 'admin')"
              class="mb-2"
            >
              <b-button
                variant="primary"
                size="md"
                @click="privateMessageModalDisplay=!privateMessageModalDisplay"
                class="m-2"
              >
                Envoyer un message
                <i class="fa fa-paper-plane fa-lg fa-fw"></i>
              </b-button>
              <b-button variant="primary" size="md" to="/chat" class="m-2">
                Démarrer un chat
                <i class="fa fa-comments fa-lg fa-fw"></i>
              </b-button>
            </div>
            <div v-if="currentUser.presentation" class="user-presentation mb-2">
              <h3>Présentation</h3>
              <div>{{ currentUser.presentation }}</div>
            </div>
            <div
              v-if="friendship && friendship.accepted === true || loggedUser.role === 'admin'"
              class="user-friends"
            >
              <h3>Amis{{ currentUser.friendships ? ' (' + currentUser.friendships.filter(e => e.accepted === true && e.fromUser && e.toUser).length + ')' : null }}</h3>
              <b-list-group>
                <b-list-group-item
                  v-for="friendship in currentUser.friendships"
                  :key="friendship._id"
                  v-if="friendship.accepted === true && friendship.fromUser && friendship.toUser"
                  class="container-fluid pull-right mb-1 p-0"
                >
                  <a
                    :href="`/profile/${currentUser.id === friendship.fromUser._id ? friendship.toUser._id : friendship.fromUser._id}`"
                    class="pull-left"
                  >
                    <img
                      :src="currentUser.id === friendship.fromUser._id ? friendship.toUser.picture : friendship.fromUser.picture"
                      alt="Photo de profil"
                      width="42"
                      height="42"
                      class="rounded-circle m-2"
                    >
                    {{ currentUser.id === friendship.fromUser._id ? friendship.toUser.username : friendship.fromUser.username }}
                  </a>
                </b-list-group-item>
              </b-list-group>
            </div>
          </b-card>
        </b-col>
        <b-col cols="12" lg="9" class="mb-4">
          <b-card
            v-if="loggedUser.id === currentUser.id || (loggedUser.id !== currentUser.id && friendship && friendship.accepted === true) || loggedUser.role === 'admin'"
          >
            <h2 class="mb-4">Mur de {{ currentUser.firstname }}</h2>
            <b-form @submit.prevent="onPublicationSubmit" v-if="loggedUser.id === currentUser.id">
              <vue-editor
                id="newPublicationInput"
                v-model="newPublication"
                v-validate="'required|max:20000'"
                :state="!errors.has('newPublication')"
                aria-describedby="newPublicationLiveFeedback"
                data-vv-name="newPublication"
                data-vv-as="&quot;Nouvelle Publication&quot;"
                data-vv-scope="publication"
                :editorOptions="editorSettings"
                class="publication mb-2"
                :disabled="userPublicationsStatus.publishing || userPublicationsStatus.replying"
              ></vue-editor>
              <div
                id="newPublicationLiveFeedback"
                v-if="errors.has('publication.newPublication')"
                class="invalid-feedback mb-2"
                :style="[errors.has('publication.newPublication') ? {'display': 'block'} : {'display': 'none'}]"
              >{{ errors.first('publication.newPublication') }}</div>
              <b-button
                type="submit"
                variant="primary"
                size="lg"
                :disabled="userPublicationsStatus.publishing || userPublicationsStatus.replying"
              >
                Publier
                <i class="fa fa-plus fa-lg fa-fw"></i>
              </b-button>
              <i
                v-show="userPublicationsStatus.publishing"
                class="loader fa fa-spinner fa-spin fa-2x"
              ></i>
            </b-form>
            <div v-if="userPublications.totalCount > 0">
              <b-pagination
                align="center"
                size="md"
                :total-rows="userPublications.totalCount"
                v-model="currentPage"
                :per-page="nbPublicationPerPage"
                @change="onPageChange"
              ></b-pagination>
              <b-list-group>
                <b-list-group-item
                  v-for="publication in userPublications.data"
                  :key="publication.id"
                  class="container-fluid pull-right mb-4"
                >
                  <div class="origin-publication">
                    <p class="publication-author pull-left mb-1 pl-1">
                      <b-img
                        class="profile-picture"
                        rounded="circle"
                        height="30"
                        width="30"
                        alt="Photo auteur"
                        :src="publication.author.picture"
                      />
                      {{ publication.author.username }}, le {{ publication.createdAt | moment("DD/MM/YY [à] HH[h]mm") }}
                    </p>
                    <b-button
                      v-if="loggedUser.id === currentUser.id || loggedUser.role === 'admin'"
                      class="pull-right mb-1"
                      variant="danger"
                      size="sm"
                      title="Supprimer"
                      v-confirm="{
                                loader: true,
                                okText: 'Confirmer',
                                cancelText: 'Annuler',
                                ok: dialog => onDeletePublication(dialog, publication.id),
                                message: 'Souhaitez-vous vraiment supprimer cette publication?'
                              }"
                    >
                      <i class="fa fa-times"></i>
                    </b-button>
                    <b-card class="publication-content ql-editor" v-html="publication.content"></b-card>
                  </div>
                  <a
                    href="#"
                    class="reply-link"
                    v-show="!publication.showReply"
                    @click.prevent="publication.showReply=!publication.showReply;$forceUpdate()"
                  >Répondre</a>
                  <b-form
                    class="mt-3"
                    @submit.prevent="onReplySubmit(publication.id)"
                    v-show="publication.showReply"
                  >
                    <vue-editor
                      :id="`replyPublicationsInput_${publication.id}`"
                      v-model="replyPublications[publication.id]"
                      v-validate="'required|max:20000'"
                      :state="!errors.has(`replyPublications_${publication.id}`)"
                      :aria-describedby="`replyPublicationsLiveFeedback_${publication.id}`"
                      :data-vv-name="`replyPublications_${publication.id}`"
                      data-vv-as="&quot;Réponse à une publication&quot;"
                      :data-vv-scope="`reply_${publication.id}`"
                      :editorOptions="editorSettings"
                      class="publication mb-2"
                      :disabled="userPublicationsStatus.publishing || userPublicationsStatus.replying"
                    ></vue-editor>
                    <div
                      :id="`replyPublicationsLiveFeedback_${publication.id}`"
                      v-if="errors.has(`reply_${publication.id}.replyPublications_${publication.id}`)"
                      class="invalid-feedback mb-2"
                      :style="[errors.has(`reply_${publication.id}.replyPublications_${publication.id}`) ? {'display': 'block'} : {'display': 'none'}]"
                    >{{ errors.first(`reply_${publication.id}.replyPublications_${publication.id}`) }}</div>
                    <b-button
                      type="submit"
                      variant="primary"
                      size="md"
                      :disabled="userPublicationsStatus.publishing || userPublicationsStatus.replying"
                      class="mb-0"
                    >
                      Répondre
                      <i class="fa fa-reply fa-md fa-fw"></i>
                    </b-button>
                    <i
                      v-show="userPublicationsStatus.replying"
                      class="loader fa fa-spinner fa-spin fa-2x"
                    ></i>
                  </b-form>
                  <div class="comments mt-3 pb-2" v-if="publication.replies.length > 0">
                    <h3>Commentaire{{ publication.replies.length > 1 ? 's' : null }}:</h3>
                    <div
                      class="reply-publication mb-3 pl-2 pr-2"
                      v-show="index < 1 || publication.replies.showAll"
                      v-for="(reply, index) in publication.replies"
                      :key="reply.id"
                    >
                      <p class="publication-author pull-left mb-1 pl-1">
                        <b-img
                          class="profile-picture"
                          rounded="circle"
                          height="30"
                          width="30"
                          alt="Photo auteur"
                          :src="reply.author && reply.author.picture ? reply.author.picture : 'https://gravatar.com/avatar?d=mp'"
                        />
                        {{ reply.author && reply.author.username ? reply.author.username : 'Utilisateur supprimé'}}, le {{ reply.createdAt | moment("DD/MM/YY [à] HH[h]mm") }}
                      </p>
                      <b-button
                        v-if="loggedUser.id === currentUser.id || loggedUser.role === 'admin'"
                        class="pull-right mb-1"
                        variant="danger"
                        size="sm"
                        title="Supprimer"
                        v-confirm="{
                                  loader: true,
                                  okText: 'Confirmer',
                                  cancelText: 'Annuler',
                                  ok: dialog => onDeletePublication(dialog, reply._id),
                                  message: 'Souhaitez-vous vraiment supprimer ce commentaire?'
                                }"
                      >
                        <i class="fa fa-times"></i>
                      </b-button>
                      <b-card class="publication-content ql-editor" v-html="reply.content"></b-card>
                    </div>
                    <a
                      href="#"
                      class="showall-link"
                      v-show="publication.replies.length > 1 && !publication.replies.showAll"
                      @click.prevent="publication.replies.showAll=!publication.replies.showAll;$forceUpdate()"
                    >Voir tous les commentaires</a>
                  </div>
                </b-list-group-item>
              </b-list-group>
              <b-pagination
                align="center"
                size="md"
                :total-rows="userPublications.totalCount"
                v-model="currentPage"
                :per-page="nbPublicationPerPage"
                @change="onPageChange"
              ></b-pagination>
            </div>
            <div v-if="userPublications.totalCount === 0">Aucune publication pour le moment</div>
          </b-card>
          <b-card
            v-if="loggedUser.id !== currentUser.id && friendship === null && loggedUser.role !== 'admin'"
          >
            <img height="120" width="120" alt="Interdit" src="../assets/forbidden.svg">
            <br>
            <br>Faites une demande d'ajout en ami à ce musicien pour afficher tout son profil
            <br>
            <br>
            <b-button
              variant="primary"
              size="md"
              @click="sendFriendRequest({ fromUser: loggedUser.id, toUser: currentUser.id })"
              class="mb-0"
              :disabled="friendshipStatus.sending"
            >
              Demande d'ajout
              <i class="fa fa-plus fa-fw"></i>
            </b-button>
            <i v-show="friendshipStatus.sending" class="loader fa fa-spinner fa-spin fa-2x"></i>
          </b-card>
          <b-card
            v-if="loggedUser.id !== currentUser.id && friendship && friendship.accepted === false && loggedUser.role !== 'admin'"
          >En attente de la validation de la demande d'ajout en ami depuis le {{ friendship.createdAt | moment("DD/MM/YY") }}</b-card>
        </b-col>
      </b-row>
    </b-container>
    <b-modal
      ref="privateMessageModal"
      ok-title="Annuler"
      @hide="privateMessageModalDisplay=!privateMessageModalDisplay"
      :visible="privateMessageModalDisplay"
      :title="`Envoyer un message privé à ${currentUser.username}`"
      lazy
      centered
      ok-only
    >
      <b-form @submit.prevent="onPrivateMessageSubmit">
        <b-input-group>
          <b-form-textarea
            id="privateMessageInput"
            name="privateMessage"
            rows="10"
            max-rows="15"
            :no-resize="true"
            maxlength="20000"
            v-model="privateMessage"
            v-validate="'required|max:20000'"
            :state="!errors.has('privateMessage')"
            aria-describedby="privateMessageLiveFeedback"
            placeholder="Entrez votre message ici"
            data-vv-as="&quot;Message&quot;"
            data-vv-scope="privateMessage"
            size="lg"
          ></b-form-textarea>
          <b-form-invalid-feedback
            id="privateMessageLiveFeedback"
            v-if="errors.has('privateMessage.privateMessage')"
            :style="[errors.has('privateMessage.privateMessage') ? {'display': 'block'} : {'display': 'none'}]"
          >{{ errors.first('privateMessage.privateMessage') }}</b-form-invalid-feedback>
        </b-input-group>
        <b-button type="submit" variant="primary" size="lg" class="m-2">
          Envoyer
          <i class="fa fa-paper-plane fa-lg fa-fw"></i>
        </b-button>
      </b-form>
    </b-modal>
  </section>
</template>

<script>
import Quill from "quill";
import "quill-emoji/dist/quill-emoji";
const ShortNameEmoji = Quill.import("modules/emoji-shortname");
const ToolbarEmoji = Quill.import("modules/emoji-toolbar");
const TextAreaEmoji = Quill.import("modules/emoji-textarea");
import { VueEditor, Quill as QuillVueEditor } from "vue2-editor";
import emojiMap from "quill-emoji/src/emoji-map";
const Embed = QuillVueEditor.import("blots/embed");
class EmojiBlot extends Embed {
  static create(value) {
    let node = super.create();
    if (typeof value === "object") {
      EmojiBlot.buildSpan(value, node);
    } else if (typeof value === "string") {
      const valueObj = emojiMap[value];
      if (valueObj) {
        EmojiBlot.buildSpan(valueObj, node);
      }
    }
    return node;
  }
  static value(node) {
    return node.dataset.name;
  }
  static buildSpan(value, node) {
    node.setAttribute("data-name", value.name);
    let emojiSpan = document.createElement("span");
    emojiSpan.classList.add(this.emojiClass);
    emojiSpan.classList.add(this.emojiPrefix + value.name);
    emojiSpan.innerText = String.fromCodePoint("0x" + value.unicode);
    node.appendChild(emojiSpan);
  }
}
EmojiBlot.blotName = "emoji";
EmojiBlot.className = "ql-emojiblot";
EmojiBlot.tagName = "span";
EmojiBlot.emojiClass = "ap";
EmojiBlot.emojiPrefix = "ap-";
QuillVueEditor.register(
  {
    "formats/emoji": EmojiBlot,
    "modules/emoji-shortname": ShortNameEmoji,
    "modules/emoji-toolbar": ToolbarEmoji,
    "modules/emoji-textarea": TextAreaEmoji
  },
  true
);
import { mapState, mapActions } from "vuex";
import { instrumentService } from "../services";
import { userProfileMixin } from "./mixins/user";

export default {
  name: "UserProfile",
  components: {
    VueEditor
  },
  mixins: [userProfileMixin],
  data: function() {
    return {
      privateMessageModalDisplay: false,
      privateMessage: null,
      friendship: null,
      userInstruments: null,
      newPublication: null,
      replyPublications: [],
      currentPage: 1,
      nbPublicationPerPage: 3,
      editorSettings: {
        placeholder: "Partagez vos dernières nouvelles ici !",
        modules: {
          toolbar: {
            container: [
              [{ size: ["small", false, "large"] }],
              ["bold", "italic", "underline", "strike"],
              [{ color: [] }, { background: [] }],
              ["blockquote", "code-block"],
              [{ header: [3, 4, 5, 6, false] }],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ script: "sub" }, { script: "super" }],
              [{ indent: "-1" }, { indent: "+1" }],
              [{ direction: "rtl" }],
              [{ font: [] }],
              [{ align: [] }],
              ["clean"],
              ["link"],
              ["emoji"]
            ],
            handlers: { emoji: function() {} }
          },
          "emoji-shortname": true,
          "emoji-toolbar": true,
          "emoji-textarea": true
        }
      }
    };
  },
  mounted: function() {
    this.initProfile();
  },
  computed: {
    ...mapState({
      currentUser: state => state.users.current.user,
      loggedUser: state => state.account.user,
      loggedUserStatus: state => state.account.status,
      userPublications: state => state.publication.publications,
      userPublicationsStatus: state => state.publication.status,
      friendshipStatus: state => state.friendship.status
    })
  },
  watch: {
    userPublicationsStatus: function(newVal) {
      this.newPublication = newVal.published ? null : this.newPublication;
      this.replyPublications = newVal.published ? [] : this.replyPublications;
      if (newVal.published || newVal.deleted) {
        this.getAll({
          author: this.$route.params.userId || this.loggedUser.id,
          page: this.currentPage,
          limit: this.nbPublicationPerPage
        });
      }
    },
    currentUser: function(newVal) {
      if (newVal.friendships) {
        const that = this;
        this.friendship =
          newVal.friendships.find(
            friendship =>
              friendship.fromUser._id === that.loggedUser.id ||
              friendship.toUser._id === that.loggedUser.id
          ) || null;
      }
    },
    friendshipStatus: function(newVal) {
      if (newVal.sent || newVal.updated || newVal.deleted) {
        const that = this;
        this.friendship =
          this.currentUser.friendships.find(
            friendship =>
              friendship.fromUser === that.loggedUser.id ||
              friendship.toUser === that.loggedUser.id
          ) || null;
      }
    }
  },
  methods: {
    ...mapActions("users", ["get", "sendPrivateMessage"]),
    ...mapActions("publication", ["send", "getAll", "destroy"]),
    ...mapActions("friendship", ["sendFriendRequest"]),
    initProfile() {
      this.get(this.$route.params.userId)
        .then(() => instrumentService.getAll())
        .then(
          instruments =>
            (this.userInstruments = this.getInstruments(
              instruments,
              this.currentUser
            ))
        )
        .then(() =>
          this.getAll({
            author: this.$route.params.userId || this.loggedUser.id,
            page: this.currentPage,
            limit: this.nbPublicationPerPage
          })
        );
    },
    onPublicationSubmit() {
      this.$validator.validateAll("publication").then(valid => {
        if (valid) {
          this.send({
            author: this.loggedUser.id,
            content: this.newPublication
          });
        }
      });
    },
    onReplySubmit(origin) {
      this.$validator.validateAll(`reply_${origin}`).then(valid => {
        if (valid) {
          this.send({
            author: this.loggedUser.id,
            content: this.replyPublications[origin],
            origin
          });
        }
      });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.getAll({
        author: this.loggedUser.id,
        page: page,
        limit: this.nbPublicationPerPage
      });
    },
    addEmoji(emoji) {
      const cursorPosition = this.currentTextarea.selectionEnd;
      const start = this.currentTextarea.value.substring(
        0,
        this.currentTextarea.selectionStart
      );
      const end = this.currentTextarea.value.substring(
        this.currentTextarea.selectionStart
      );
      this.currentTextarea.value = start + emoji.native + end;
      this.currentTextarea.focus();
      this.$nextTick(() => {
        this.currentTextarea.selectionEnd =
          cursorPosition + emoji.native.length;
      });
    },
    onDeletePublication(dialog, publicationId) {
      this.destroy(publicationId).then(() => dialog.close());
    },
    onPrivateMessageSubmit() {
      this.$validator.validateAll("privateMessage").then(valid => {
        if (valid) {
          this.sendPrivateMessage({
            fromUser: this.loggedUser,
            toUser: this.currentUser,
            message: this.privateMessage
          });
          this.privateMessage = null;
          this.$refs.privateMessageModal.hide();
        }
      });
    }
  }
};
</script>

<style>
@import url("../../node_modules/quill-emoji/dist/quill-emoji.css");

.user-name,
.user-infos,
.user-instruments {
  color: #2aab2a;
  font-family: "Amaranth", sans-serif;
  font-size: 1.2rem;
}
.user-infos span {
  padding: 0 0.25rem;
}
.user-presentation h3,
.user-friends h3 {
  color: #2aab2a;
  font-family: "Amaranth", sans-serif;
  font-size: 1.2rem;
  text-align: left;
}
.user-presentation div {
  color: #2aab2a;
  text-align: justify;
  max-height: 5rem;
  overflow-y: auto;
}
.user-friends .list-group {
  max-height: 16rem;
  overflow-y: auto;
}
.list-group-item {
  background-color: #fff8d9;
  border-radius: 0.25rem;
  border: 1px solid #ccc !important;
  padding: 0.5rem;
}
.card.publication-content {
  background-color: #fff;
  border: 1px solid #ccc;
  padding: 1rem;
  text-align: initial;
  height: 100%;
  width: 100%;
  min-height: 100%;
  max-height: 10rem;
  overflow-y: auto;
}
.publication-author {
  color: #2aab2a;
  text-align: left;
  font-size: 0.7rem;
  font-weight: bold;
}
.publication {
  background-color: #fff;
}
.publication .ql-container.ql-disabled:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);
}
.publication .ql-toolbar {
  background-color: #32cd32;
  border-radius: 0.25rem 0.25rem 0 0;
}
.publication .ql-color-label {
  opacity: 1 !important;
}
.publication .ql-picker-label {
  color: #fff;
  font-weight: bold;
}
.publication .ql-picker-label:hover,
.publication .ql-picker.ql-expanded .ql-picker-label {
  color: #fff !important;
}
.publication .ql-picker-label.ql-active {
  color: #444 !important;
}
.publication .ql-picker-options {
  color: #32cd32 !important;
}
.publication .ql-picker-options .ql-picker-item .ql-stroke {
  stroke: #32cd32 !important;
}
.publication .ql-stroke:not(.ql-color-label) {
  stroke: #fff !important;
}
.publication .ql-fill:not(.ql-color-label) {
  fill: #fff !important;
}
.publication .ql-active .ql-stroke:not(.ql-color-label) {
  stroke: #444 !important;
}
.publication .ql-active .ql-fill:not(.ql-color-label) {
  fill: #444 !important;
}
.publication .textarea-emoji-control .ql-stroke {
  stroke: #32cd32 !important;
}
.publication .textarea-emoji-control .ql-fill {
  fill: #32cd32 !important;
  stroke: #32cd32 !important;
}
.publication .ql-container {
  border-radius: 0 0 0.25rem 0.25rem;
}
.publication .ql-container .ql-editor {
  height: 100%;
  min-height: 100%;
  max-height: 10rem;
  overflow-y: auto;
}
.comments {
  background-color: #f8f8f8;
  border: 1px solid #32cd32;
  border-radius: 0.25rem;
}
.comments h3 {
  background-color: #32cd32;
  color: #fff;
  font-family: "Amaranth", sans-serif;
  font-size: 1.2rem;
  text-align: left;
  padding: 0 0.5rem;
}
.profile-picture {
  border: 1px solid #2aab2a;
}
.list-group-item .btn-danger {
  padding: 0.1rem 0.35rem;
}
.reply-link,
.showall-link {
  color: #2cb62c;
  font-weight: bold;
}
</style>

